import React from 'react'

import { Trans } from 'next-i18next'
import Link from 'next/link'

import * as S from './Notice.styles'

export const Notice = () => {
  return (
    <S.Root>
      <Trans
        i18nKey="b2c.registration.book"
        components={[<Link href={process.env.NEXT_PUBLIC_DENTAL_URL} key={0} />]}
      />
    </S.Root>
  )
}
